module.exports = __webpack_public_path__ + "static/media/monster-09.14200d59.png";